import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    layout: css({
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),

    back: css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: isHosTheme ? theme.palette.text.primary : theme.palette.customBlue,
        marginBottom: isHosTheme ? '22px' : '60px',
        cursor: 'pointer',
        textDecoration: isHosTheme ? 'underline' : 'none',
        ':hover': {
            textDecoration: 'underline',
        },
        [theme.breakpoints.down('lg')]: {
            textDecoration: 'underline',
            paddingTop: '20px',
            margin: isHosTheme ? '20px auto' : '0 auto',
        },
    }),

    icon: css({
        marginRight: '10px',
        '.arrow-color': {
            fill: isHosTheme ? theme.palette.text.primary : theme.palette.customBlue,
        },
    }),

    wrapper: css({
        marginTop: '32px',
    }),

    cta: css({
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'center',
        marginTop: '30px',
        marginBottom: '30px',
    }),

    nextStepWrap: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        alignItems: 'center',
    }),
};
